import { ActionButton } from '@if/mui'
import { useTranslation } from 'react-i18next'

/**
 * What a tool dialog resolves with when the agent asked to leave the editor rather than come
 * back to it. The tools used to thread a second `onCloseAll` callback down for this; the
 * answer now travels back with the dialog's own result and the editor's runner closes itself,
 * so a tool never reaches past its own instance.
 */
export const RETURN_TO_CALENDAR = 'returnToCalendar'

/** A tool's own result, or the request to close the editor under it. */
export type ToolResult<T> = T | typeof RETURN_TO_CALENDAR

export const isReturnToCalendar = <T,>(result: ToolResult<T> | null): result is typeof RETURN_TO_CALENDAR =>
  result === RETURN_TO_CALENDAR

interface ReturnToCalendarActionProps {
  onReturn: () => void
}

/** The footer's far-left way out of a tool *and* the editor under it, in one click. */
const ReturnToCalendarAction = ({ onReturn }: ReturnToCalendarActionProps) => {
  const { t } = useTranslation()
  return <ActionButton onClick={onReturn}>{t('loan.payment.returnToCalendar')}</ActionButton>
}

export default ReturnToCalendarAction
